import { useEffect } from 'react'

import { useAppSelector } from '../../../store/hooks'
import { useActions } from '../../../store/use-actions'
import {
  getDisallowedStrategiesFromPendingState,
  getDisallowedStrategiesFromSelectedState
} from '../../00-builder/state/mappers'
import { FundingSource } from '../../02-terms/state/terms-slice'
import { actions as rawActions } from '../state/strategy-slice'
import { StrategyStepStateless } from '../templates'

export function StrategyStep() {
  const builderState = useAppSelector(state => state.builder)
  const state = useAppSelector(state => state.strategy)
  const portfolio = useAppSelector(state => state.portfolio)
  const terms = useAppSelector(state => state.terms)
  const actions = useActions(rawActions)

  useEffect(() => {
    const params = {
      client: builderState.client,
      accountId: builderState.accountId
    }
    if (params.client && params.accountId && !state.isInited) {
      actions.init(params)
    }
    const pendingAccountState = builderState.savedState?.account?.pendingAccountState
    if (pendingAccountState) {
      actions.setStrategiesExisting({
        disallowedStrategies: getDisallowedStrategiesFromPendingState(pendingAccountState as any),
        isTransfer: terms.terms.fundingSource === FundingSource.Transfer
      })
    } else {
      // For a new trade for the first time or creating a new edit for the first time
      actions.setStrategiesExisting({
        disallowedStrategies: getDisallowedStrategiesFromSelectedState(
          portfolio,
          builderState.businessUnit
        ),
        isTransfer: terms.terms.fundingSource === FundingSource.Transfer
      })
    }
  }, [
    state.isInited,
    builderState.client,
    builderState.accountId,
    portfolio,
    builderState.savedState?.account?.pendingAccountState,
    builderState.businessUnit,
    actions,
    terms.terms.fundingSource
  ])
  useEffect(() => {
    actions.setBuilderErrors(builderState.errors)
  }, [actions, builderState.errors])

  const onSaveAndContinue = () => {
    actions.moveNext()
  }
  const onMoveBack = () => {
    actions.moveBack()
  }
  const onCloseAssetInspection = () => {
    actions.stopInspectingAsset()
  }

  return (
    <StrategyStepStateless
      actions={actions}
      state={state}
      onCloseInspection={onCloseAssetInspection}
      onMoveBack={onMoveBack}
      onSaveAndContinue={onSaveAndContinue}
    />
  )
}
